import React from 'react';
import { Flex, Image, Menu, MenuList, MenuGroup, MenuItem, MenuDivider, Box } from '@chakra-ui/react';
import { AccountUser } from './AccountUser';
import LanguageSelect from './LanguageSelect';
import OptionsButtons from './OptionsButtons';
import { Link as RouterLink } from 'react-router-dom';
import { useRouteHelper } from '../../../hooks/routesHelpers';

export default function NavBar() {
  const { setRoute } = useRouteHelper();
  return (
    <>
      <Box position="sticky" top="0" zIndex="10" boxShadow="md" bg="white">
        <Flex
          py={4}
          px={{ base: 4, md: 6 }}
          maxW="container.xl"
          mx="auto"
          justifyContent="space-between"
          alignItems="center"
          color="#203b54"
          bg="white"
        >
          <Menu>
            <MenuList>
              <MenuGroup title="Profile">
                <RouterLink to={setRoute('dashboard.profile')}>
                  <MenuItem>My Account</MenuItem>
                </RouterLink>
                <RouterLink to={setRoute('becomeAHost.propertyInformation')}>
                  <MenuItem>List a property </MenuItem>
                </RouterLink>
              </MenuGroup>
              <MenuDivider />
              <MenuGroup title="Help">
                <MenuItem>Docs</MenuItem>
                <MenuItem>FAQ</MenuItem>
              </MenuGroup>
            </MenuList>
          </Menu>
          <Flex alignItems="center">
            <RouterLink to={setRoute('home')}>
              <Image
                className="lazyload"
                width={{ base: '60px', md: '80px' }}
                h="auto"
                objectFit="cover"
                src="/assets/logo/logo_small.svg"
                alt="Flate"
                ml={{
                  base: '8px',
                  md: '0',
                }}
              />
            </RouterLink>
          </Flex>
          <OptionsButtons />
          <Flex>
            <LanguageSelect />
            <AccountUser />
          </Flex>
        </Flex>
      </Box>
    </>
  );
}
